import { makeFieldValueDbModule } from '../makeFieldValueDbModule';
import { clear as injuredBodyPartsServiceClear } from './injuredBodyPartsService';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';
import { fieldValueContracts } from 'shared/domain/fieldValue/fieldValueContracts';
import { EditableFieldValuesEntityName } from 'shared/domain/fieldValue/fields';

export const {
  clear,
  quantity,
  get,
  getOne,
  addBatch,
  updateBatch,
  removeBatch,
} = makeFieldValueDbModule({
  tableName: 'injuredBodyParts',
  serviceTableName: 'injuredBodyPartsService',
  serviceClearFunction: injuredBodyPartsServiceClear,
  broadcastClearFunction: makeClearPublisher(fieldValueContracts[EditableFieldValuesEntityName.injuredBodyPart]),
});
